import AppHeader from '../AppHeader'

export default {
  name: 'ability-question-edit',
  created () {
    this.search()
  },
  data () {
    return {
      title: '',
      skillType: '',
      questions: [],
      canValidate: true,
      isSearchEnd: false,
      savingFlag: false
    }
  },
  computed: {
    validation: function () {
      var v = {
        title: !!this.title,
        not_input: !!this.title
      }
      v.content = []
      v.answerContent1 = []
      v.answerContent2 = []
      v.answerContent3 = []
      v.answerContent4 = []
      v.content_all = true
      v.answerContent_all = true
      for (let index in this.questions) {
        let vc = !!(this.questions[index].content)
        let va1 = !!(this.questions[index].answerContent1)
        let va2 = !!(this.questions[index].answerContent2)
        let va3 = !!(this.questions[index].answerContent3)
        let va4 = !!(this.questions[index].answerContent4)
        v.content.push(vc)
        v.answerContent1.push(va1)
        v.answerContent2.push(va2)
        v.answerContent3.push(va3)
        v.answerContent4.push(va4)
        v.content_all &= vc
        v.answerContent_all &= va1
        v.answerContent_all &= va2
        v.answerContent_all &= va3
        v.answerContent_all &= va4
      }
      v.not_input = v.not_input && !!v.content.length && !!v.content_all && !!v.answerContent_all

      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      this.$store.dispatch('GET_ABILITY_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        this.title = res.title.title
        this.questions = res.question_details
        if (res.title.skillType === 1) {
          this.skillType = 'personal'
        } else if (res.title.skillType === 2) {
          this.skillType = 'business'
        }
        this.isSearchEnd = true
      })
      .catch(err => console.log(err))
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('ABILITY_QUESTION_UPDATE', {
        id: this.$route.params.id,
        data: {
          title: this.title,
          skillType: this.skillType,
          contents: this.questions
        }
      })
      .then(res => {
        this.$router.push({path: '/ability_question'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/ability_question')
    },
    addContent: function () {
      let question = {
        content: null,
        answerContent1: '',
        answerContent2: '',
        answerContent3: '',
        answerContent4: '',
        displayOrder: this.questions.length + 1
      }
      this.questions.splice(this.questions.length, 0, question)
    },
    deleteContent: function (index) {
      this.questions.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/ability-question-edit.js